"use strict";
/* global google */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
var GmPlacesController = /** @class */ (function (_super) {
    __extends(GmPlacesController, _super);
    function GmPlacesController(config, dialog, $timeout, $interpolate, $scope, book) {
        'ngInject';
        var _this = _super.call(this, $scope, book) || this;
        _this.config = config;
        _this.dialog = dialog;
        _this.$timeout = $timeout;
        _this.$interpolate = $interpolate;
        _this.gmPredictions = null;
        _this.loading = false;
        _this.apiError = false;
        _this.htmlDivElement = document.createElement('div');
        $scope.$watch(function () { return book; }, function () { return _this.onChange(); }, true);
        $scope.$watch(function () { return _this.form.isDisabled(); }, function (value) {
            if (value) {
                _this.address = null;
                _this.form.value = '';
                _this.book.set(_this.prefix, _this.id, _this.form.value);
                _this.form.setValidity(_this.form.validation, true);
            }
            else {
                var valid = _this.form.hasValidation('required') ? !!_this.form.value : true;
                _this.form.setValidity(_this.form.validation, valid);
            }
        }, true);
        _this.form.value = _this.book.get(_this.prefix, _this.id) || '';
        _this.address = {
            street: _this.getForeignValue(_this.gmPlacesOptions.street),
            number: _this.getForeignValue(_this.gmPlacesOptions.number),
            postal: _this.getForeignValue(_this.gmPlacesOptions.postal),
            city: _this.getForeignValue(_this.gmPlacesOptions.city),
            lat: _this.getForeignValue(_this.gmPlacesOptions.lat),
            lng: _this.getForeignValue(_this.gmPlacesOptions.lng)
        };
        if (!_this.apiError && !window.hasOwnProperty('google')) {
            _this.apiError = true;
            _this.dialog.show(_this.config.localeJson.ui.dialogs.mapsNoApiKey.text, {
                title: _this.config.localeJson.ui.dialogs.mapsNoApiKey.title,
                buttons: [{ label: _this.config.localeJson.ui.dialogs.mapsNoApiKey.button.ok }]
            });
            return _this;
        }
        _this.gmAutocomplete = new google.maps.places.AutocompleteService();
        _this.gmPlaces = new google.maps.places.PlacesService(_this.htmlDivElement);
        _this.resetSession();
        return _this;
    }
    GmPlacesController.prototype.onChange = function () {
        if (this.loading
            || !this.addressChanged()
            || this.form.isDisabled()) {
            return;
        }
        if (this.form.value) {
            this.resetPlace();
            if (this.form.hasValidation('required')) {
                this.form.setValidity(this.form.validation, false);
            }
        }
        if (this.$interpolate("{{" + this.gmPlacesOptions.street + "}}")(this.book).trim() &&
            this.$interpolate("{{" + this.gmPlacesOptions.number + "}}")(this.book).trim()) {
            var query = this.$interpolate("{{" + this.gmPlacesOptions.street + "}} {{" + this.gmPlacesOptions.number + "}} {{" + this.gmPlacesOptions.postal + "}} {{" + this.gmPlacesOptions.city + "}}")(this.book);
            this.getPredictions(query);
        }
        else {
            this.gmPredictions = null;
        }
    };
    GmPlacesController.prototype.onSelectPlace = function (id) {
        this.loading = true;
        this.form.value = id;
        this.gmPredictions = null;
        this.book.set(this.prefix, this.id, this.form.value);
        this.getPlace(this.form.value);
        if (this.form.hasValidation('required')) {
            this.form.setValidity(this.form.validation, true);
        }
    };
    GmPlacesController.prototype.getForeignValue = function (key) {
        var _a = key.split('.'), group = _a[0], id = _a[1];
        return this.book.get(group, id) || '';
    };
    GmPlacesController.prototype.resetSession = function () {
        this.gmSessionToken = new google.maps.places.AutocompleteSessionToken();
    };
    GmPlacesController.prototype.getPredictions = function (input) {
        var _this = this;
        if (!input.length) {
            return;
        }
        var params = {
            input: input,
            types: ['address'],
            sessionToken: this.gmSessionToken
        };
        try {
            this.gmAutocomplete.getPlacePredictions(params).then(function (response) {
                _this.$timeout(function () {
                    _this.gmPredictions = response.predictions;
                });
            });
        }
        catch (_a) {
            if (!this.apiError) {
                this.apiError = true;
                this.dialog.show(this.config.localeJson.ui.dialogs.mapsNoApiKey.text, {
                    title: this.config.localeJson.ui.dialogs.mapsNoApiKey.title,
                    buttons: [{ label: this.config.localeJson.ui.dialogs.mapsNoApiKey.button.ok }]
                });
            }
        }
    };
    GmPlacesController.prototype.resetPlace = function () {
        this.address = null;
        this.form.value = '';
        this.book.set(this.prefix, this.id, this.form.value);
        var lat = this.gmPlacesOptions.lat.split('.');
        this.book.set(lat[0], lat[1], '');
        var lng = this.gmPlacesOptions.lng.split('.');
        this.book.set(lng[0], lng[1], '');
    };
    GmPlacesController.prototype.getPlace = function (id) {
        var _this = this;
        var params = {
            placeId: id,
            sessionToken: this.gmSessionToken,
            fields: ['address_component', 'geometry']
        };
        this.gmPlaces.getDetails(params, function (response) {
            _this.$timeout(function () {
                _this.address = {
                    street: _this.extractAddressComponent(response, 'route'),
                    number: _this.extractAddressComponent(response, 'street_number'),
                    postal: _this.extractAddressComponent(response, 'postal_code'),
                    city: _this.extractAddressComponent(response, 'locality') ||
                        _this.extractAddressComponent(response, 'postal_town') ||
                        _this.extractAddressComponent(response, 'neighborhood'),
                    lat: _this.extractCoordinates(response, 'lat'),
                    lng: _this.extractCoordinates(response, 'lng')
                };
                _this.updateInputFileds();
            });
        });
        this.resetSession();
    };
    GmPlacesController.prototype.extractAddressComponent = function (place, type) {
        var component = place.address_components.find(function (c) { return c.types.includes(type); });
        return component ? component.long_name : '';
    };
    GmPlacesController.prototype.extractCoordinates = function (place, type) {
        var fn = place.geometry.location[type];
        return fn ? fn() : '';
    };
    GmPlacesController.prototype.addressChanged = function () {
        if (!this.address) {
            return true;
        }
        var address = {
            street: this.$interpolate("{{" + this.gmPlacesOptions.street + "}}")(this.book),
            number: this.$interpolate("{{" + this.gmPlacesOptions.number + "}}")(this.book),
            postal: this.$interpolate("{{" + this.gmPlacesOptions.postal + "}}")(this.book),
            city: this.$interpolate("{{" + this.gmPlacesOptions.city + "}}")(this.book)
        };
        return address.street !== this.address.street
            || address.number !== this.address.number
            || address.postal !== this.address.postal
            || address.city !== this.address.city;
    };
    GmPlacesController.prototype.updateInputFileds = function () {
        var _this = this;
        for (var _i = 0, _a = Object.entries(this.address); _i < _a.length; _i++) {
            var _b = _a[_i], k = _b[0], v = _b[1];
            var _c = this.gmPlacesOptions[k].split('.'), p = _c[0], i = _c[1];
            this.book.set(p, i, String(v));
        }
        this.$timeout(function () {
            _this.loading = false;
        });
    };
    return GmPlacesController;
}(form_1.FormOptionController));
exports.GmPlacesController = GmPlacesController;
function GmPlacesDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/gm-places.html',
        controller: GmPlacesController,
        controllerAs: 'gmPlacesCtrl'
    };
}
exports.GmPlacesDirective = GmPlacesDirective;
